import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from '@components/common';

const OptionContainer = styled(Box)`
  cursor: pointer;
  user-select: none;
  display: inline-block;
`;

function PropertyValue(props) {
  const { isDisabled, innerProps, data } = props;
  if (isDisabled) {
    return null;
  }

  const { name, address, state, city, zipcode } = data;
  const fullAddress = `${address}, ${city}, ${state} ${zipcode}`;

  return (
    <OptionContainer {...innerProps}>
      <Text color="darkerGray">{name}</Text>
      <Text color="darkGray" fontSize={0}>
        {fullAddress}
      </Text>
    </OptionContainer>
  );
}

PropertyValue.propTypes = {
  innerProps: PropTypes.any,
  isDisabled: PropTypes.bool,
  data: PropTypes.object
};

export default PropertyValue;
